import {Affix, Button, Card, Col, Drawer, message, Row, Statistic, Tag, Tooltip} from "antd";
import {useCallback, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {GeoCoords} from "../../../dto/geoCoords";
import jobApiService from "../../../service/jobApiService";
import twilioApiService from "../../../service/twilioApiService";
import RemoteRoomComp from "./RemoteRoomComp";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {VideoStatus} from "../../../enums/VideoStatus";
import {WifiOutlined} from "@ant-design/icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBriefcase, faCircle, faIdCard, faUserLarge, faUserLargeSlash} from "@fortawesome/free-solid-svg-icons";
import GeolocationSendComp from "../common/GeolocationSendComp";
import {PoweroffOutlined} from '@ant-design/icons/lib';
import keycloak from "../../../security/KeyclockConfig";
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone';
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser';
import {StompSessionProvider} from "react-stomp-hooks";

interface JobDetail {
    assignedBy: string,
    informerEmail: string,
    informerMobileNo: string,
    informerName: string,
    jobDescription: string,
    jobNumber: string,
    identityDocumentTypeCode: string,
    jobId: number,
    idNo: string,
    callDetailsDtoList: []
}

const baseUrl: string | undefined = process.env.BASE_API_URL ? process.env.BASE_API_URL : "";

export default function MainRemoteVideoView() {
    const routeParams: { remoteUserAccessToken: "0" } = useParams();
    const [username, setUsername] = useState('');
    const [roomName, setRoomName] = useState('');
    const [token, setToken] = useState('');
    const [videoStatus, setVideoStatus] = useState<VideoStatus>(VideoStatus.OFFLINE);
    const [participantConnectingStatus, setParticipantConnectingStatus] = useState<ParticipantStatus>(ParticipantStatus.PENDING);
    const [geoCoords, setGeoCoords] = useState<GeoCoords>({longitude: 0, latitude: 0});
    const [longitude, setLongitude] = useState<number>(0);
    const [jobDetail, setJobDetail] = useState<JobDetail>({
        assignedBy: "",
        jobId: 0,
        callDetailsDtoList: [],
        informerEmail: "",
        informerMobileNo: "",
        informerName: "",
        jobDescription: "",
        jobNumber: "",
        identityDocumentTypeCode: "",
        idNo: ""
    });

    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";
    const history = useHistory();
    const onVideoStatusProgress = (status: VideoStatus) => {
        setVideoStatus(status);
    }

    const onParticipantConnectingStatusProgress = (status: ParticipantStatus) => {
        setParticipantConnectingStatus(status);
    }


    useEffect(() => {
        function getGeolocation() {
            if (navigator.geolocation) {
                navigator.geolocation.watchPosition(position => {
                    setLongitude(position.coords.longitude)
                    setGeoCoords({longitude: position.coords.longitude, latitude: position.coords.latitude});
                });
            } else {
                console.log('Geolocation is not supported by this browser.');
            }
        }

        getGeolocation();
    }, [longitude]);

    useEffect(() => {
        setVideoStatus(VideoStatus.CONNECTING);
        if (username === '') {
            jobApiService.getJobDetailDtoByRemoteUserAccessToken(routeParams.remoteUserAccessToken).then(res => {
                let callDetail = res.data.results.callDetailsDtoList[0];
                setJobDetail(res.data.results);
                console.log(callDetail);
                setUsername(callDetail.remoteUserAccessToken);
                setRoomName(callDetail.roomName);
                twilioApiService.getTwilioToken(callDetail.remoteUserAccessToken, callDetail.roomName).then(res1 => {
                    setToken(res1.data.results.token);
                }).catch(reason => {
                    console.log(reason.response.data.errors[0]);
                    message.error(reason.response.data.errors[0].errorMessage);
                })
            }).catch(reason => {
                message.error(reason.response.data.results).then(() => {
                    if (keycloak.authenticated) {
                        // keycloak.logout({redirectUri: `${redirectUri}`})
                        keycloak.logout({redirectUri: window.location.origin});
                    }
                });


            })

        }

        return () => {
            setToken("");
        };

    }, [routeParams.remoteUserAccessToken]);


    const handleLogout = useCallback((event: any) => {
        setToken('');
        history.push('/workflow/customer/dashboard')
    }, []);


    let render;
    if (token) {
        render = (
            <RemoteRoomComp roomName={roomName} token={token} handleLogout={handleLogout}
                            setVideoStatusProgress={onVideoStatusProgress}
                            setParticipantConnectingStatus={onParticipantConnectingStatusProgress}
                            username={username}
                            remoteUserAccessToken={routeParams.remoteUserAccessToken}
                            geoCoords={geoCoords}/>
        );
        // } else {
        //     render = <div className='please_wait_div'>
        //                 <Spin size={"large"} ></Spin>
        //                 <h6>
        //                     Please wait...
        //                 </h6>
        //
        //             </div>
    }

    const logout = (e: any) => {
        if (keycloak.authenticated) {
            // keycloak.logout({redirectUri: `${redirectUri}workflow/customer/dashboard`})
            keycloak.logout({redirectUri: window.location.origin});
        }
    }
    const [open, setOpen] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };
    return <>
        {/*<Spin spinning={isSpinnerLoading} tip="Loading" size="large">*/}
        <Affix offsetTop={0}>
            <Row className='logo-area-row video-verify-header'>
                <Col lg={24} sm={24} md={24} xs={24} className='logo-area-col'>
                    <div>
                        <h1 className='create-account-text'>Video Verification</h1>
                        <h5 className='easy-step-text'>Let's Verify Your Identity</h5>
                    </div>

                    <div>
                        <Tooltip title='Sign Out'>
                            <Button onClick={logout}><PoweroffOutlined/></Button>
                        </Tooltip>

                    </div>
                </Col>
            </Row>
        </Affix>
        <StompSessionProvider
            connectHeaders={{
                accessToken: keycloak.token ? keycloak.token : "",
                username: username,
            }}
            url={`${baseUrl}/video/socket`}
            onWebSocketClose={(evt) => {
                console.log('WebSocket closed: ', evt);
            }}
        >
            <Row gutter={[16, 0]} className='video-call-component-row'>
                <Col xxl={{span: 14, offset: 5}} xl={{span: 18, offset: 3}} lg={{span: 22, offset: 1}}
                     md={{span: 22, offset: 1}} sm={{span: 24}} className='video-call-main-col'>

                    <Card size='small' className='main-video-card'>
                        <Row>
                            <Col span={24} style={{overflow: 'auto'}}>
                                <div className="top-info-row">

                                    <div className='meet-info-card-admin hide-on-mobile'>
                                        <div className="meet-info-icon">
                                            <FontAwesomeIcon icon={faBriefcase}/>
                                        </div>
                                        <Statistic className='admin-meet-info' title="Job Number"
                                                   formatter={(value: number) => String(value).replace(',', '')}
                                                   value={jobDetail.jobNumber}/>
                                    </div>
                                    <div className='meet-info-card-admin hide-on-mobile'>
                                        <div className="meet-info-icon">
                                            <FontAwesomeIcon icon={faIdCard}/>
                                        </div>
                                        <Statistic className='admin-meet-info' title="ID Number"
                                                   formatter={(value: string) => value.replace(',', '')}
                                                   value={jobDetail.idNo}/>
                                    </div>
                                    <div className='meet-info-card-admin hide-on-mobile'>
                                        <div className="meet-info-icon">
                                            <FontAwesomeIcon icon={faUser}/>
                                        </div>
                                        <Statistic className='admin-meet-info' title="Customer Name"
                                                   value={jobDetail.informerName}/>
                                    </div>
                                    <div className='meet-info-card-admin hide-on-mobile'>
                                        <div className="meet-info-icon">
                                            <FontAwesomeIcon icon={faPhone}/>
                                        </div>
                                        <Statistic className='admin-meet-info' title="Mobile Number"
                                                   formatter={(value: string) => value.replace(',', '')}
                                                   value={jobDetail.informerMobileNo}/>
                                    </div>

                                    {/*<Statistic title="Reported Date" value={'2023-07-10'}/>*/}
                                    {<GeolocationSendComp username={username} latitude={geoCoords.latitude}
                                                          longitude={geoCoords.longitude}/>}

                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div className='mobile-font-size'>
                                            <div>
                                                {
                                                    videoStatus == VideoStatus.OFFLINE
                                                    || videoStatus === VideoStatus.CONNECTING
                                                    || videoStatus === VideoStatus.ROOM_DISCONNECTED
                                                        ?
                                                        <div color="red"><FontAwesomeIcon color="red"
                                                                                          icon={faCircle}/> {videoStatus == VideoStatus.OFFLINE ? "Offline" : videoStatus}
                                                        </div>
                                                        : <div color="green"><FontAwesomeIcon color="green"
                                                                                              icon={faCircle}/> {videoStatus}
                                                        </div>
                                                }

                                            </div>
                                            <div>
                                                <WifiOutlined style={{color: "green", marginRight: 5}}/>
                                                4G
                                            </div>
                                        </div>
                                        <div style={{marginLeft: 12}}>
                                            <div className='top-row-tag'>
                                                {
                                                    participantConnectingStatus == ParticipantStatus.PARTICIPANT_DISCONNECTED
                                                    || participantConnectingStatus === ParticipantStatus.PENDING
                                                    || participantConnectingStatus === ParticipantStatus.PARTICIPANT_RECONNECTING
                                                    || participantConnectingStatus === ParticipantStatus.DISCONNECTED
                                                    || participantConnectingStatus === ParticipantStatus.PARTICIPANT_RECONNECTED
                                                        ?
                                                        <Tooltip placement="bottom" title={participantConnectingStatus}>
                                                            <Tag className='user-connect-tag'
                                                                 color="red"><FontAwesomeIcon
                                                                icon={faUserLargeSlash}/></Tag>
                                                        </Tooltip>
                                                        :
                                                        <Tooltip placement="bottom" title={participantConnectingStatus}>
                                                            <Tag className='user-connect-tag'
                                                                 color="green"><FontAwesomeIcon
                                                                icon={faUserLarge}/></Tag>
                                                        </Tooltip>
                                                }
                                            </div>
                                            <div></div>
                                        </div>
                                    </div>

                                    <div className="show-meeting-info-mobile">
                                        <Drawer title="Meeting Details" className='meeting-details-drawer'
                                                placement="bottom" onClose={onClose} open={open} mask={false}>

                                            <div className='meet-info-card'>
                                                <div className="meet-info-icon">
                                                    <FontAwesomeIcon icon={faBriefcase}/>
                                                </div>
                                                <Statistic className='mobile-meet-info' title="Job Number"
                                                           formatter={(value: number) => String(value).replace(',', '')}
                                                           value={jobDetail.jobNumber}/>
                                            </div>

                                            <div className='meet-info-card'>
                                                <div className="meet-info-icon">
                                                    <FontAwesomeIcon icon={faIdCard}/>
                                                </div>
                                                <Statistic className='mobile-meet-info' title="ID Number"
                                                           formatter={(value: string) => value.replace(',', '')}
                                                           value={jobDetail.idNo}/>
                                            </div>

                                            <div className='meet-info-card'>
                                                <div className="meet-info-icon">
                                                    <FontAwesomeIcon icon={faUser}/>
                                                </div>
                                                <Statistic className='mobile-meet-info' title="Customer Name"
                                                           value={jobDetail.informerName}/>
                                            </div>

                                            <div className='meet-info-card'>
                                                <div className="meet-info-icon">
                                                    <FontAwesomeIcon icon={faPhone}/>
                                                </div>
                                                <Statistic className='mobile-meet-info' title="Mobile Number"
                                                           formatter={(value: string) => value.replace(',', '')}
                                                           value={jobDetail.informerMobileNo}/>
                                            </div>

                                            {<GeolocationSendComp username={username} latitude={geoCoords.latitude}
                                                                  longitude={geoCoords.longitude}/>}
                                        </Drawer>
                                        <Button className="show-meeting-info-mobile-button" type="primary" size='small'
                                                ghost onClick={showDrawer}>Meeting Details</Button>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="video-render">
                                    {render}
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>

        </StompSessionProvider>
        {/*</Spin>*/}

    </>;
}
